// extracted by mini-css-extract-plugin
module.exports = {"grid":"columns-module--grid--1k7ZE","gridItem":"columns-module--grid-item--24k59"};